import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';
import { FileText } from 'lucide-react';

const formatRelativeTime = (draftTime) => {
  const diff = Date.now() - new Date(draftTime).getTime();
  const minutes = Math.floor(diff / (1000 * 60));
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));

  if (minutes < 1) return '刚刚保存';
  if (minutes < 60) return `${minutes}分钟前保存`;
  if (hours < 24) return `${hours}小时前保存`;
  return `${days}天前保存`;
};

const DraftRestoreDialog = ({
  open,
  onRestore,
  onDiscard,
  draftTime,
  dialogTitle = '恢复草稿',
  dialogMessage = '检测到未提交的草稿数据，是否恢复？',
}) => {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onDiscard()} data-testid="draft-restore-dialog">
      <DialogContent className="sm:max-w-md" onInteractOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <FileText className="h-5 w-5 text-primary" />
            {dialogTitle}
          </DialogTitle>
          <DialogDescription>
            {dialogMessage}
          </DialogDescription>
          {draftTime && (
            <p className="text-sm text-muted-foreground pt-1">
              {formatRelativeTime(draftTime)}
            </p>
          )}
        </DialogHeader>

        <DialogFooter className="flex-col sm:flex-row gap-2">
          <Button
            variant="outline"
            onClick={onDiscard}
            data-testid="draft-discard-btn"
          >
            放弃
          </Button>
          <Button
            onClick={onRestore}
            data-testid="draft-restore-btn"
          >
            恢复
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DraftRestoreDialog;
